export const LABELS = {
  TITLE: 'Sync profile',
  SUBTITLE:
    'Some of your submitted applications are out of date with your recent changes to your profile',
  BUTTON: 'Resolve',
};
